import { useIntl } from "react-intl";

export default function NoPermission() {
  const { messages } = useIntl();

  return <div>{messages["common.noPermission"] as string}</div>;
}
